// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import ToggleButton from './ToggleButton';

// Styles
import './ToggleInput.scss';

const ToggleInput = ({
    value = 1,
    label,
    active,
    onChange,
    noTransition,
    disabled,
    error,
    inputId,
    duration,
    easing,
    className,
}) => (
    <label className={classNames('ToggleInput', className, { disabled, error })}>
        <input
            id={inputId}
            type="checkbox"
            className="checkbox"
            value={value}
            checked={active}
            onChange={onChange}
            disabled={disabled}
        />
        <ToggleButton active={active} noTransition={noTransition} duration={duration} easing={easing} />
        <span className="text">{label}</span>
    </label>
);

ToggleInput.propTypes = {
    onChange: PropTypes.func,
    active: PropTypes.bool,
    noTransition: PropTypes.bool,
    value: PropTypes.number,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    inputId: PropTypes.string,
    className: PropTypes.string,
    // Transition
    duration: PropTypes.number,
    easing: PropTypes.string,
};

export default ToggleInput;
